<div class="alert alert-success" role="alert" *ngIf="model.success_message" [innerHTML]="model.success_message"></div>
<div class="alert alert-warning" role="alert" *ngIf="model.error_message" [innerHTML]="model.error_message"></div>